let defaultState = ['李雷']
export default function (state = defaultState,action){
    return [...state]
}